import { message } from 'antd';
import ClockoutController from '../../core/clockout.controller';
import Inherit from '../../core/inherit';
import LedgerDelegate from './ledger.delegate';

class LedgerController extends Inherit(ClockoutController, LedgerDelegate) {
    async initialize() {
        // Check if user has valid data (not just an empty object)
        if (!this.user || !this.user.access || this.user.access.length === 0) {
            this.navigateLogin();
            return;
        }

        this.setState({ user: this.data.user });
        try {
            // exclude: '' opts back into service_fee rows -- see api.js#requestLedger.
            const ledger = await this.data.fetchLedger({ exclude: '' });
            this.setState({ ledger, rows: ledger?.items || ledger?.transactions, loading: false });
        }
        catch (error) {
            // `fetchLedger` rethrows now. Without this the rejection escapes
            // `initialize`, `loading` never flips and the whole Page spins
            // forever on `isLoading` — a worse failure than the empty table it
            // used to render.
            console.error('Error loading ledger:', error);
            this.setState({ ledger: [], rows: [], loading: false });
            message.error('Failed to load the ledger. Please try again.');
        }
    }
}

export default LedgerController;
